import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingUploadInformation: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 3.05H32v25.91h-1.52Zm-1.53 25.91h1.53v1.52h-1.53Zm0-27.43h1.53v1.52h-1.53ZM3.05 30.48h25.9V32H3.05Zm22.86-19.81h-1.53V9.15h-1.52V7.62h-1.52v1.53h-1.53v1.52h-1.52v1.52h-1.53v1.53h3.05v7.62h4.57v-7.62h3.05v-1.53h-1.52zM6.1 24.38h19.81v1.53H6.1Zm1.52-3.04h4.57v-7.62h3.05v-1.53h-1.52v-1.52h-1.53V9.15h-1.52V7.62H9.15v1.53H7.62v1.52H6.1v1.52H4.57v1.53h3.05zM3.05 0h25.9v1.53H3.05ZM1.53 28.96h1.52v1.52H1.53Zm0-27.43h1.52v1.52H1.53ZM0 3.05h1.53v25.91H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingUploadInformation
